# Route: /errors/not-found
# Generic 404 landing page. The xp87-error-router.js helper redirects here
# when any page-level data fetch fails with a "404"-bearing error.
# Permission: none (public — must render even when the user is unauthenticated)

page-error-not-found:
  type: Page
  archetype: error
  meta:
    title: $t.errors.not_found.meta_title
    route: /errors/not-found
    layout: shell
    auth: stub
  spatial:
    display: flex
    direction: column
    gap: $spacing.xl
    padding: $spacing.xl
    overflow: auto
    align: center
    justify: center
    responsive:
      sm:
        padding: $spacing.md
        gap: $spacing.md
  tokens:
    background: $color_scheme.light.color.surface
  children:
    - error-not-found

# Top-level node — the scenario addresses it via
#   assert-visible: { node_id: error-not-found }
# Rendered as ErrorState (icon + title + body + retry button) so it carries
# role="alert" and matches the canonical XP85-DS-007 "error" data state.
error-not-found:
  type: ErrorState
  icon: $icon.warning
  title: $t.errors.not_found.title
  content: $t.errors.not_found.body
  action_label: $t.errors.not_found.btn_home
  # This page declares no data block, so the emitter's default retry handler
  # would call a `_fetchPageData` it never defines and the click would throw.
  # `CirRouteTests.ErrorStateAction_OnADataLessPage_Navigates` holds that.
  action_route: /today
  spatial:
    padding: $spacing.xl
    align: center
  tokens:
    background: $color_scheme.light.color.surface-elevated
    border: $border.default
    radius: $radius.md
    color: $color_scheme.light.color.on-surface
